import http, { buildApiFileUrl } from "./http";

export async function getSubjectsByClass(classId) {
    const res = await http.get(`/api/classes/${encodeURIComponent(classId)}/subjects`);
    return res.data;
}

export async function getSubjectsAdminByClass(classId) {
    const res = await http.get(`/api/classes/${encodeURIComponent(classId)}/subjects/admin`);
    return res.data;
}

export async function createSubject(classId, payload) {
    const res = await http.post(
        `/api/classes/${encodeURIComponent(classId)}/subjects`,
        payload
    );
    return res.data;
}

export async function setSubjectEnabled(classId, subjectSlug, enabled) {
    const res = await http.patch(
        `/api/classes/${encodeURIComponent(classId)}/subjects/${encodeURIComponent(subjectSlug)}/enabled`,
        { enabled }
    );
    return res.data;
}

export async function getAuthorsBySubject(classId, subjectSlug) {
    const res = await http.get(
        `/api/classes/${encodeURIComponent(classId)}` +
        `/subjects/${encodeURIComponent(subjectSlug)}` +
        `/authors`
    );
    return res.data;
}

export async function getAuthorsAdminBySubject(classId, subjectSlug) {
    const res = await http.get(
        `/api/classes/${encodeURIComponent(classId)}` +
        `/subjects/${encodeURIComponent(subjectSlug)}` +
        `/authors/admin`
    );
    return res.data;
}

export async function setAuthorEnabled(classId, subjectSlug, authorSlug, enabled) {
    const res = await http.patch(
        `/api/classes/${encodeURIComponent(classId)}` +
        `/subjects/${encodeURIComponent(subjectSlug)}` +
        `/authors/${encodeURIComponent(authorSlug)}` +
        `/enabled`,
        { enabled }
    );
    return res.data;
}

export async function getTextbooks() {
    const res = await http.get("/api/textbooks");
    return res.data;
}

export async function patchAuthor(classId, subjectSlug, authorSlug, payload) {
    const res = await http.patch(
        `/api/classes/${encodeURIComponent(classId)}` +
        `/subjects/${encodeURIComponent(subjectSlug)}` +
        `/authors/${encodeURIComponent(authorSlug)}`,
        payload
    );
    return res.data;
}

export async function createAuthor(classId, subjectSlug, payload) {
    const res = await http.post(
        `/api/classes/${encodeURIComponent(classId)}` +
        `/subjects/${encodeURIComponent(subjectSlug)}` +
        `/authors`,
        payload
    );
    return res.data;
}

export async function deleteAuthor(classId, subjectSlug, authorSlug) {
    const res = await http.delete(
        `/api/classes/${encodeURIComponent(classId)}` +
        `/subjects/${encodeURIComponent(subjectSlug)}` +
        `/authors/${encodeURIComponent(authorSlug)}`
    );
    return res.data;
}

export async function getSubjectsCatalogAdmin() {
    const res = await http.get(`/api/subjects-catalog/admin`);
    return res.data;
}

export async function createCatalogSubject(payload) {
    const res = await http.post(`/api/subjects-catalog`, payload);
    return res.data;
}

export async function setCatalogSubjectEnabled(subjectSlug, enabled) {
    const res = await http.patch(
        `/api/subjects-catalog/${encodeURIComponent(subjectSlug)}/enabled`,
        { enabled }
    );
    return res.data;
}

export async function getModulesByAuthor(classId, subjectSlug, authorSlug) {
    const res = await http.get(
        `/api/classes/${encodeURIComponent(classId)}` +
        `/subjects/${encodeURIComponent(subjectSlug)}` +
        `/authors/${encodeURIComponent(authorSlug)}` +
        `/modules`
    );
    return res.data;
}

export async function getModulesAdminByAuthor(classId, subjectSlug, authorSlug) {
    const res = await http.get(
        `/api/classes/${encodeURIComponent(classId)}` +
        `/subjects/${encodeURIComponent(subjectSlug)}` +
        `/authors/${encodeURIComponent(authorSlug)}` +
        `/modules/admin`
    );
    return res.data;
}

export async function getModuleSections(classId, subjectSlug, authorSlug) {
    const res = await http.get(
        `/api/classes/${encodeURIComponent(classId)}` +
        `/subjects/${encodeURIComponent(subjectSlug)}` +
        `/authors/${encodeURIComponent(authorSlug)}` +
        `/module-sections`
    );
    return res.data;
}

export async function getModuleSectionsAdmin(classId, subjectSlug, authorSlug) {
    const res = await http.get(
        `/api/classes/${encodeURIComponent(classId)}` +
        `/subjects/${encodeURIComponent(subjectSlug)}` +
        `/authors/${encodeURIComponent(authorSlug)}` +
        `/module-sections/admin`
    );
    return res.data;
}

export async function createModuleSection(classId, subjectSlug, authorSlug, payload) {
    const res = await http.post(
        `/api/classes/${encodeURIComponent(classId)}` +
        `/subjects/${encodeURIComponent(subjectSlug)}` +
        `/authors/${encodeURIComponent(authorSlug)}` +
        `/module-sections`,
        payload
    );
    return res.data;
}

export async function patchModuleSection(classId, subjectSlug, authorSlug, sectionSlug, payload) {
    const res = await http.patch(
        `/api/classes/${encodeURIComponent(classId)}` +
        `/subjects/${encodeURIComponent(subjectSlug)}` +
        `/authors/${encodeURIComponent(authorSlug)}` +
        `/module-sections/${encodeURIComponent(sectionSlug)}`,
        payload
    );
    return res.data;
}

export async function deleteModuleSection(classId, subjectSlug, authorSlug, sectionSlug) {
    const res = await http.delete(
        `/api/classes/${encodeURIComponent(classId)}` +
        `/subjects/${encodeURIComponent(subjectSlug)}` +
        `/authors/${encodeURIComponent(authorSlug)}` +
        `/module-sections/${encodeURIComponent(sectionSlug)}`
    );
    return res.data;
}

export async function createModule(classId, subjectSlug, authorSlug, payload) {
    const res = await http.post(
        `/api/classes/${encodeURIComponent(classId)}` +
        `/subjects/${encodeURIComponent(subjectSlug)}` +
        `/authors/${encodeURIComponent(authorSlug)}` +
        `/modules`,
        payload
    );
    return res.data;
}

export async function setModuleEnabled(
    classId,
    subjectSlug,
    authorSlug,
    moduleSlug,
    enabled
) {
    const res = await http.patch(
        `/api/classes/${encodeURIComponent(classId)}` +
        `/subjects/${encodeURIComponent(subjectSlug)}` +
        `/authors/${encodeURIComponent(authorSlug)}` +
        `/modules/${encodeURIComponent(moduleSlug)}` +
        `/enabled`,
        { enabled }
    );
    return res.data;
}

export async function patchModule(
    classId,
    subjectSlug,
    authorSlug,
    moduleSlug,
    payload
) {
    const res = await http.patch(
        `/api/classes/${encodeURIComponent(classId)}` +
        `/subjects/${encodeURIComponent(subjectSlug)}` +
        `/authors/${encodeURIComponent(authorSlug)}` +
        `/modules/${encodeURIComponent(moduleSlug)}`,
        payload
    );
    return res.data;
}

export async function deleteModule(classId, subjectSlug, authorSlug, moduleSlug) {
    const res = await http.delete(
        `/api/classes/${encodeURIComponent(classId)}` +
        `/subjects/${encodeURIComponent(subjectSlug)}` +
        `/authors/${encodeURIComponent(authorSlug)}` +
        `/modules/${encodeURIComponent(moduleSlug)}`
    );
    return res.data;
}

export async function getModuleAdminBySlug(classId, subjectSlug, authorSlug, moduleSlug) {
    const res = await http.get(
        `/api/classes/${encodeURIComponent(classId)}` +
        `/subjects/${encodeURIComponent(subjectSlug)}` +
        `/authors/${encodeURIComponent(authorSlug)}` +
        `/modules/${encodeURIComponent(moduleSlug)}` +
        `/admin`
    );
    return res.data;
}

export async function saveModuleContentJson(classId, subjectSlug, authorSlug, moduleSlug, contentJson) {
    const res = await http.patch(
        `/api/classes/${encodeURIComponent(classId)}` +
        `/subjects/${encodeURIComponent(subjectSlug)}` +
        `/authors/${encodeURIComponent(authorSlug)}` +
        `/modules/${encodeURIComponent(moduleSlug)}`,
        { contentJson }
    );
    return res.data;
}

export async function getModuleBySlug(classId, subjectSlug, authorSlug, moduleSlug) {
    const res = await http.get(
        `/api/classes/${encodeURIComponent(classId)}` +
        `/subjects/${encodeURIComponent(subjectSlug)}` +
        `/authors/${encodeURIComponent(authorSlug)}` +
        `/modules/${encodeURIComponent(moduleSlug)}`
    );
    return res.data;
}

export async function saveModuleQuestions(classId, subjectSlug, authorSlug, moduleSlug, questions) {
    const res = await http.patch(
        `/api/classes/${encodeURIComponent(classId)}` +
        `/subjects/${encodeURIComponent(subjectSlug)}` +
        `/authors/${encodeURIComponent(authorSlug)}` +
        `/modules/${encodeURIComponent(moduleSlug)}`,
        { questions }
    );
    return res.data;
}

/**
 * POST /api/images/upload
 * file: MultipartFile
 * description?: string
 */
export async function uploadImage(file, description) {
    const fd = new FormData();
    fd.append("file", file);
    if (description) fd.append("description", description);

    const res = await http.post("/api/images/upload", fd, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data; // { id, filename, originalFilename, accessPath, ... }
}

export async function getMyImages() {
    const res = await http.get("/api/images/my");
    return res.data; // список Image (як у бекенді)
}

// якщо треба адмін-список:
export async function getAllImagesAdmin() {
    const res = await http.get("/api/images/admin");
    return res.data;
}

/** Хелпер: зробити url до файлу */
export function getImageUrlByFilename(filename) {
    return buildApiFileUrl(`/api/images/file/${encodeURIComponent(filename)}`);
}

/**
 * POST /api/audio/upload
 * file: MultipartFile
 * description?: string
 */
export async function uploadAudio(file, description) {
    const fd = new FormData();
    fd.append("file", file);
    if (description) fd.append("description", description);

    const res = await http.post("/api/audio/upload", fd, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
}

export async function getMyAudio() {
    const res = await http.get("/api/audio/my");
    return res.data;
}

export async function getAllAudioAdmin() {
    const res = await http.get("/api/audio/admin");
    return res.data;
}

export function getAudioUrlByFilename(filename) {
    return buildApiFileUrl(`/api/audio/file/${encodeURIComponent(filename)}`);
}

/**
 * POST /api/pdfs/upload
 * file: MultipartFile
 * description?: string
 */
export async function uploadPdf(file, description) {
    const fd = new FormData();
    fd.append("file", file);
    if (description) fd.append("description", description);

    const res = await http.post("/api/pdfs/upload", fd, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
}

export async function getMyPdfs() {
    const res = await http.get("/api/pdfs/my");
    return res.data;
}

export async function getAllPdfsAdmin() {
    const res = await http.get("/api/pdfs/admin");
    return res.data;
}

export function getPdfUrlByFilename(filename) {
    return buildApiFileUrl(`/api/pdfs/file/${encodeURIComponent(filename)}`);
}
